const payments = [

  {
    text: "PAY SA",//safepay
    enable: true,
    type: "BANKCARD",
    rechargeCodes: [
      {
        type: "1402",
        text: "QRIS",
      },
      {
        type: "1408",
        text: "QRIS Code",
      },
      {
        type: "1401",
        text: "Online Banking",
      },
      {
        type: "1403",
        text: "DANA",
      },
      {
        type: "1404",
        text: "OVO",
      },
      {
        type: "1405",
        text: "LinkAja",
      },
      {
        type: "1406",
        text: "DANA Native",
      },
      // {
      //   type: "1407",
      //   text: "USDT",
      //   extraParamName: "extra",
      //   extraOptions: [
      //     {
      //       value: "TRC20",
      //       text: "TRC20",
      //     },
      //     {
      //       value: "BEP20",
      //       text: "BEP20",
      //     },
      //     {
      //       value: "ERC20",
      //       text: "ERC20",
      //     },
      //   ],
      // },
    ],
    isHideBankCode: true,
    merchantId: 43,
    img: ["../assets/images/wallets/ind_pay_sa.png"],
    minDepositAmount: 5000,
    maxDepositAmount: 1000000,
    minWithdrawAmount: 6000000,
    maxWithdrawAmount: 300000000,
    checkPrecedence: (phone) => {
      return false;
    },
  },

  {
    text: "PAY F",//futurepay
    enable: true,
    type: "BANKCARD",
    rechargeCodes: [
      {
        type: "qris",
        text: "QRIS",
      },
      {
        type: "bri",
        text: "BRI",
      },
      {
        type: "bni",
        text: "BNI",
      },
      {
        type: "mandiri",
        text: "Mandiri",
      },
    ],
    isHideBankCode: true,
    merchantId: 51,
    img: ["../assets/images/wallets/futurepay.png"],
    minDepositAmount: 5000,
    maxDepositAmount: 1000000,
    minWithdrawAmount: 6000000,
    maxWithdrawAmount: 300000000,
    checkPrecedence: (phone) => {
      return true;
    },
  },

  {
    text: "PAY GHS1",//kukbankpay
    enable: true,
    type: "BANKCARD",
    isHideBankCode: true,
    merchantId: 55,
    img: ["../assets/images/home/kukbankpay.png"],
    minDepositAmount: 5000,
    maxDepositAmount: 1000000,
    minWithdrawAmount: 20000,
    maxWithdrawAmount: 1000000,
    checkPrecedence: (phone) => {
      return true;
    },
  },

  {
    text: "PAY GR",//paygrid
    enable: true,
    merchantId: 62,
    type: "BANKCARD",
    isHideBankCode: true,
    img: ["../assets/images/wallets/geti.png"],
    minDepositAmount: 5000,
    maxDepositAmount: 1000000,
    minWithdrawAmount: 10000,
    maxWithdrawAmount: 1000000,
    checkPrecedence: (phone) => {
      return false;
    },
  },

  {
    text: "PAY OW",//helloowen 
    enable: true,
    type: "BANKCARD",
    isHideBankCode: true,
    merchantId: 67,
    img: ["../assets/images/wallets/ind_helloowen.png"],
    minDepositAmount: 5000,
    maxDepositAmount: 1000000,
    minWithdrawAmount: 6000000,
    maxWithdrawAmount: 300000000,
    checkPrecedence: (phone) => {
      return true;
    },
  },



  {
    text: "PAY YE",//yerepay
    enable: true,
    type: "BANKCARD",
    rechargeCodes: [
      {
        type: "QR",
        text: "QRIS",
        bankCodeOptions: [
          {
            value: "dynamic",
            text: "QRIS",
          },
        ],
      },
      {
        type: "EWALLET",
        text: "E-Wallet",
        bankCodeOptions: [
          {
            value: "DANA",
            text: "DANA",
          },
          {
            value: "OVO",
            text: "OVO",
          },
          {
            value: "LINKAJA",
            text: "LinkAja",
          },
        ],
      },
      {
        type: "VA",
        text: "Virtual Account",
        bankCodeOptions: [
          {
            value: "002",
            text: "BRI",
          },
        ],
      },
    ],
    rechargeTypeLabel: "Type",
    bankCodeSelectLabel: "Bank / E-Wallet",
    withdrawTypes: [
      {
        type: "BANKCARD",
        text: "Bank Card",
        bankCodeOptions: [
          {
            value: "002",
            text: "BRI",
          },
          {
            value: "008",
            text: "Mandiri",
          },
          {
            value: "009",
            text: "BNI",
          },
          {
            value: "011",
            text: "Danamon",
          },
          {
            value: "013",
            text: "Permata",
          },
          {
            value: "014",
            text: "BCA",
          },
          {
            value: "022",
            text: "CIMB",
          },
        ],
      },
      {
        type: "EWALLET",
        text: "E-Wallet",
        bankCodeOptions: [
          {
            value: "DANA",
            text: "DANA",
          },
          {
            value: "OVO",
            text: "OVO",
          },
          {
            value: "GOPAY",
            text: "GoPay",
          },
          {
            value: "LINKAJA",
            text: "LinkAja",
          },
          {
            value: "SHOPEEPAY",
            text: "ShopeePay",
          },
        ],
      },
    ],
    isHideBankCode: true,
    merchantId: 68,
    minDepositAmount: 5000,
    maxDepositAmount: 1000000,
    minWithdrawAmount: 6000000,
    maxWithdrawAmount: 300000000,
    checkPrecedence: () => {
      return false;
    },
  },
];

const purses = {
  27: [
    {
      icon: "../assets/images/home/jazz.png",
      text: "JAZZCASH"
    },
    {
      icon: "../assets/images/home/easypais.png",
      text: "EASYPAISA"
    },
    {
      icon: "../assets/images/home/bank.png",
      text: "BANK"
    },
  ],
  29: [
    {
      icon: "../assets/images/home/jazz.png",
      text: "JAZZCASH"
    },
    {
      icon: "../assets/images/home/easypais.png",
      text: "EASYPAISA"
    },
  ],
  32: [
    {
      icon: "../assets/images/home/jazz.png",
      text: "JAZZCASH"
    },
    {
      icon: "../assets/images/home/easypais.png",
      text: "EASYPAISA"
    },
    {
      icon: "../assets/images/home/bank.png",
      text: "BANK"
    },
  ]
}

const names = [
  {
    nameText: "Jazz cash",
  },
  {
    nameText: "Easypaisa",
  },
];

const codes = [
  {
    merchantIds: [43],
    codeId: "dana",
    codeText: "DANA",
  },
  {
    merchantIds: [43],
    codeId: "gopay",
    codeText: "GOPAY",
  },
  {
    merchantIds: [43],
    codeId: "linkaja",
    codeText: "Linkaja",
  },
  {
    merchantIds: [43],
    codeId: "ovo",
    codeText: "OVO",
  },
  {
    merchantIds: [43],
    codeId: "shopeepay",
    codeText: "ShopeePay",
  },
  {
    merchantIds: [43],
    codeId: "IDR001",
    codeText: "BANK CIMB NIAGA SYARIAH",
  },
  {
    merchantIds: [43],
    codeId: "IDR002",
    codeText: "BANK PERMATA",
  },
  {
    merchantIds: [43],
    codeId: "IDR003",
    codeText: "BANK MANDIRI",
  },
  {
    merchantIds: [43],
    codeId: "IDR004",
    codeText: "CITIBANK",
  },
  {
    merchantIds: [43],
    codeId: "IDR005",
    codeText: "BANK CAPITAL",
  },
  {
    merchantIds: [43],
    codeId: "IDR006",
    codeText: "BANK ACEH SYARIAH",
  },
  {
    merchantIds: [43],
    codeId: "IDR007",
    codeText: "BANK ARTHA GRAHA",
  },
  {
    merchantIds: [43],
    codeId: "IDR008",
    codeText: "BANK BTPN",
  },
  {
    merchantIds: [43],
    codeId: "IDR009",
    codeText: "BANK CTBC",
  },
  {
    merchantIds: [43],
    codeId: "IDR010",
    codeText: "BANK DANAMON",
  },
  {
    merchantIds: [43],
    codeId: "IDR011",
    codeText: "BANK DBS",
  },
  {
    merchantIds: [43],
    codeId: "IDR012",
    codeText: "BANK GANESHA",
  },
  {
    merchantIds: [43],
    codeId: "IDR013",
    codeText: "HSBC INDONESIA",
  },
  {
    merchantIds: [43],
    codeId: "IDR014",
    codeText: "BANK ICBC",
  },
  {
    merchantIds: [43],
    codeId: "IDR015",
    codeText: "BANK JASA JAKARTA",
  },
  {
    merchantIds: [43],
    codeId: "IDR016",
    codeText: "BANK MASPION INDONESIA",
  },
  {
    merchantIds: [43],
    codeId: "IDR017",
    codeText: "BANK MAYAPADA",
  },
  {
    merchantIds: [43],
    codeId: "IDR018",
    codeText: "BANK MAYBANK",
  },
  {
    merchantIds: [43],
    codeId: "IDR019",
    codeText: "BANK MAYORA",
  },
  {
    merchantIds: [43],
    codeId: "IDR020",
    codeText: "BANK MEGA",
  },
  {
    merchantIds: [43],
    codeId: "IDR021",
    codeText: "BANK MESTIKA DHARMA",
  },
  {
    merchantIds: [43],
    codeId: "IDR022",
    codeText: "BANK MNC INTERNASIONAL",
  },
  {
    merchantIds: [43],
    codeId: "IDR023",
    codeText: "OCBC",
  },
  {
    merchantIds: [43],
    codeId: "IDR024",
    codeText: "BPD BALI",
  },
  {
    merchantIds: [43],
    codeId: "IDR025",
    codeText: "BANK QNB",
  },
  {
    merchantIds: [43],
    codeId: "IDR026",
    codeText: "BANK SAHABAT SAMPOERNA",
  },
  {
    merchantIds: [43],
    codeId: "IDR027",
    codeText: "BANK SINARMAS",
  },
  {
    merchantIds: [43],
    codeId: "IDR028",
    codeText: "BANK UOB",
  },
  {
    merchantIds: [43],
    codeId: "IDR029",
    codeText: "BANK VICTORIA",
  },
  {
    merchantIds: [43],
    codeId: "IDR030",
    codeText: "BPD LAMPUNG",
  },
  {
    merchantIds: [43],
    codeId: "IDR031",
    codeText: "BPD PAPUA",
  },
  {
    merchantIds: [43],
    codeId: "IDR032",
    codeText: "STANDARD CHARTERED",
  },
  {
    merchantIds: [43],
    codeId: "IDR033",
    codeText: "BANK OF CHINA (HKG)",
  },
  {
    merchantIds: [43],
    codeId: "IDR034",
    codeText: "BANK PANIN",
  },
  {
    merchantIds: [43],
    codeId: "IDR035",
    codeText: "BANK NOBU",
  },
  {
    merchantIds: [43],
    codeId: "IDR036",
    codeText: "BANK BCA",
  },
  {
    merchantIds: [43],
    codeId: "IDR037",
    codeText: "BANK BCA SYARIAH",
  },
  {
    merchantIds: [43],
    codeId: "IDR038",
    codeText: "BANK BNI",
  },
  {
    merchantIds: [43],
    codeId: "IDR039",
    codeText: "BPD DIY",
  },
  {
    merchantIds: [43],
    codeId: "IDR040",
    codeText: "BANK BRI",
  },
  {
    merchantIds: [43],
    codeId: "IDR041",
    codeText: "BANK BTN",
  },
  {
    merchantIds: [43],
    codeId: "IDR042",
    codeText: "BANK Commonwealth",
  },
  {
    merchantIds: [43],
    codeId: "IDR043",
    codeText: "BANK INDEX",
  },
  {
    merchantIds: [43],
    codeId: "IDR044",
    codeText: "BANK JATENG",
  },
  {
    merchantIds: [43],
    codeId: "IDR045",
    codeText: "BANK JATIM",
  },
  {
    merchantIds: [43],
    codeId: "IDR046",
    codeText: "BANK JTRUST INDONESIA",
  },
  {
    merchantIds: [43],
    codeId: "IDR047",
    codeText: "BPD MALUKU",
  },
  {
    merchantIds: [43],
    codeId: "IDR048",
    codeText: "Bank Artos Indonesia(JAGO)",
  },
  {
    merchantIds: [43],
    codeId: "IDR049",
    codeText: "Bank Seabank Indonesia",
  },
  {
    merchantIds: [43],
    codeId: "IDR050",
    codeText: "Bank SYARIAH INDONESIA(BSI)",
  },
  {
    merchantIds: [43],
    codeId: "IDR051",
    codeText: "BANK NEO COMMERCE(BNC)",
  },

  {
    merchantIds: [51],
    codeId: "244002",
    codeText: "BRI",
  },
  {
    merchantIds: [51],
    codeId: "244008",
    codeText: "Bank Mandiri",
  },
  {
    merchantIds: [51],
    codeId: "244009",
    codeText: "Bank Negara Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244011",
    codeText: "Bank Danamon",
  },
  {
    merchantIds: [51],
    codeId: "244013",
    codeText: "Bank Permata",
  },
  {
    merchantIds: [51],
    codeId: "244014",
    codeText: "BCA",
  },
  {
    merchantIds: [51],
    codeId: "244016",
    codeText: "BII Maybank",
  },
  {
    merchantIds: [51],
    codeId: "244019",
    codeText: "Bank Panin",
  },
  {
    merchantIds: [51],
    codeId: "244022",
    codeText: "CIMB Niaga",
  },
  {
    merchantIds: [51],
    codeId: "244023",
    codeText: "Bank UOB Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244028",
    codeText: "Bank OCBC NISP",
  },
  {
    merchantIds: [51],
    codeId: "244031",
    codeText: "Citibank",
  },
  {
    merchantIds: [51],
    codeId: "244032",
    codeText: "JPMorgan Chase Bank",
  },
  {
    merchantIds: [51],
    codeId: "244036",
    codeText: "Bank China Construction Bank Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244037",
    codeText: "Bank Artha Graha Internasional",
  },
  {
    merchantIds: [51],
    codeId: "244042",
    codeText: "MUFG Bank",
  },
  {
    merchantIds: [51],
    codeId: "244046",
    codeText: "Bank DBS Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244050",
    codeText: "Standard Chartered",
  },
  {
    merchantIds: [51],
    codeId: "244054",
    codeText: "Bank Capital Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244061",
    codeText: "ANZ Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244067",
    codeText: "Deutsche Bank AG",
  },
  {
    merchantIds: [51],
    codeId: "244069",
    codeText: "Bank OF China",
  },
  {
    merchantIds: [51],
    codeId: "244076",
    codeText: "Bank Bumi Arta",
  },
  {
    merchantIds: [51],
    codeId: "244087",
    codeText: "Bank HSBC Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244088",
    codeText: "Bank Antardaerah",
  },
  {
    merchantIds: [51],
    codeId: "244089",
    codeText: "Bank Rabobank",
  },
  {
    merchantIds: [51],
    codeId: "244095",
    codeText: "Bank Jtrust Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244097",
    codeText: "Bank Mayapada International",
  },
  {
    merchantIds: [51],
    codeId: "244110",
    codeText: "BJB",
  },
  {
    merchantIds: [51],
    codeId: "244111",
    codeText: "Bank DKI",
  },
  {
    merchantIds: [51],
    codeId: "244112",
    codeText: "Bank DIY",
  },
  {
    merchantIds: [51],
    codeId: "244112S",
    codeText: "Bank DIY Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244113",
    codeText: "Bank Jateng",
  },
  {
    merchantIds: [51],
    codeId: "244114",
    codeText: "Bank Jatim",
  },
  {
    merchantIds: [51],
    codeId: "244114S",
    codeText: "Bank Jatim Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244115",
    codeText: "Bank Jambi",
  },
  {
    merchantIds: [51],
    codeId: "244115S",
    codeText: "Bank Jambi Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244116",
    codeText: "Bank Aceh",
  },
  {
    merchantIds: [51],
    codeId: "244117",
    codeText: "Bank Sumut",
  },
  {
    merchantIds: [51],
    codeId: "244117S",
    codeText: "Bank Sumut Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244118",
    codeText: "Bank Nagari",
  },
  {
    merchantIds: [51],
    codeId: "244118S",
    codeText: "Bank Nagari Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244119",
    codeText: "Bank Riau",
  },
  {
    merchantIds: [51],
    codeId: "244120",
    codeText: "Bank Sumsel Babel",
  },
  {
    merchantIds: [51],
    codeId: "244120S",
    codeText: "Bank Sumsel Babel Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244121",
    codeText: "Bank Lampung",
  },
  {
    merchantIds: [51],
    codeId: "244122",
    codeText: "Bank Kalsel",
  },
  {
    merchantIds: [51],
    codeId: "244122S",
    codeText: "Bank Kalsel Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244123",
    codeText: "Bank Kalbar",
  },
  {
    merchantIds: [51],
    codeId: "244123S",
    codeText: "Bank Kalbar Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244124",
    codeText: "Bank Kaltim",
  },
  {
    merchantIds: [51],
    codeId: "244124S",
    codeText: "Bank Kaltim Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244125",
    codeText: "Bank Kalteng",
  },
  {
    merchantIds: [51],
    codeId: "244126",
    codeText: "Bank Sulselbar",
  },
  {
    merchantIds: [51],
    codeId: "244126S",
    codeText: "Bank Sulselbar Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244127",
    codeText: "Bank Sulut",
  },
  {
    merchantIds: [51],
    codeId: "244128",
    codeText: "Bank NTB",
  },
  {
    merchantIds: [51],
    codeId: "244129",
    codeText: "Bank Bali",
  },
  {
    merchantIds: [51],
    codeId: "244130",
    codeText: "Bank NTT",
  },
  {
    merchantIds: [51],
    codeId: "244131",
    codeText: "Bank Maluku",
  },
  {
    merchantIds: [51],
    codeId: "244132",
    codeText: "Bank Papua",
  },
  {
    merchantIds: [51],
    codeId: "244133",
    codeText: "Bank Bengkulu",
  },
  {
    merchantIds: [51],
    codeId: "244134",
    codeText: "Bank Sulteng",
  },
  {
    merchantIds: [51],
    codeId: "244135",
    codeText: "Bank Sultra",
  },
  {
    merchantIds: [51],
    codeId: "244137",
    codeText: "Bank Banten",
  },
  {
    merchantIds: [51],
    codeId: "244145",
    codeText: "Bank Nusantara Parahyangan",
  },
  {
    merchantIds: [51],
    codeId: "244146",
    codeText: "Bank Of India Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244147",
    codeText: "Bank Muamalat",
  },
  {
    merchantIds: [51],
    codeId: "244151",
    codeText: "Bank Mestika",
  },
  {
    merchantIds: [51],
    codeId: "244152",
    codeText: "Bank Shinhan",
  },
  {
    merchantIds: [51],
    codeId: "244153",
    codeText: "Bank Sinarmas",
  },
  {
    merchantIds: [51],
    codeId: "244157",
    codeText: "Bank Maspion Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244161",
    codeText: "Bank Ganesha",
  },
  {
    merchantIds: [51],
    codeId: "244164",
    codeText: "Bank ICBC Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244167",
    codeText: "Bank QNB Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244200",
    codeText: "BTN",
  },
  {
    merchantIds: [51],
    codeId: "244200S",
    codeText: "BTN Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244212",
    codeText: "Bank Woori Saudara",
  },
  {
    merchantIds: [51],
    codeId: "244213",
    codeText: "Bank SMBC Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244405",
    codeText: "Bank Victoria Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244425",
    codeText: "BJB Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244426",
    codeText: "Bank Mega",
  },
  {
    merchantIds: [51],
    codeId: "244441",
    codeText: "Bank Bukopin",
  },
  {
    merchantIds: [51],
    codeId: "244451",
    codeText: "Bank Syariah Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244459",
    codeText: "Krom Bank Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244472",
    codeText: "Bank Jasa Jakarta",
  },
  {
    merchantIds: [51],
    codeId: "244484",
    codeText: "Bank KEB Hana",
  },
  {
    merchantIds: [51],
    codeId: "244485",
    codeText: "Bank MNC",
  },
  {
    merchantIds: [51],
    codeId: "244490",
    codeText: "Bank Neo Commerce",
  },
  {
    merchantIds: [51],
    codeId: "244494",
    codeText: "Bank Raya Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244498",
    codeText: "Bank SBI Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244501",
    codeText: "BCA Digital",
  },
  {
    merchantIds: [51],
    codeId: "244503",
    codeText: "Bank National Nobu",
  },
  {
    merchantIds: [51],
    codeId: "244506",
    codeText: "Bank Mega Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244513",
    codeText: "Bank INA",
  },
  {
    merchantIds: [51],
    codeId: "244517",
    codeText: "Bank Panin Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244520",
    codeText: "Bank Prima",
  },
  {
    merchantIds: [51],
    codeId: "244521",
    codeText: "Bank Syariah Bukopin",
  },
  {
    merchantIds: [51],
    codeId: "244523",
    codeText: "Bank Sahabat Sampoerna",
  },
  {
    merchantIds: [51],
    codeId: "244526",
    codeText: "Bank Oke Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244535",
    codeText: "Bank Seabank Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244536",
    codeText: "Bank BCA Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244542",
    codeText: "Bank Jago",
  },
  {
    merchantIds: [51],
    codeId: "244542S",
    codeText: "Bank Jago Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244547",
    codeText: "Bank BTPN Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244548",
    codeText: "Bank Multiarta Sentosa",
  },
  {
    merchantIds: [51],
    codeId: "244553",
    codeText: "Bank Hibank Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244555",
    codeText: "Bank Index",
  },
  {
    merchantIds: [51],
    codeId: "244559",
    codeText: "Bank CNB",
  },
  {
    merchantIds: [51],
    codeId: "244562",
    codeText: "Superbank",
  },
  {
    merchantIds: [51],
    codeId: "244564",
    codeText: "Bank Mandiri Taspen",
  },
  {
    merchantIds: [51],
    codeId: "244566",
    codeText: "Bank Victoria International",
  },
  {
    merchantIds: [51],
    codeId: "244567",
    codeText: "Allo Bank",
  },
  {
    merchantIds: [51],
    codeId: "244600",
    codeText: "ATMB LSB",
  },
  {
    merchantIds: [51],
    codeId: "244688",
    codeText: "BPR KS",
  },
  {
    merchantIds: [51],
    codeId: "244724",
    codeText: "Bank DKI Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244725",
    codeText: "Bank Jateng Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244734",
    codeText: "Bank Sinarmas Syariah",
  },
  {
    merchantIds: [51],
    codeId: "244777",
    codeText: "Finnet",
  },
  {
    merchantIds: [51],
    codeId: "244867",
    codeText: "Bank Eka",
  },
  {
    merchantIds: [51],
    codeId: "244945",
    codeText: "Bank IBK Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244949",
    codeText: "Bank CTBC Indonesia",
  },
  {
    merchantIds: [51],
    codeId: "244950",
    codeText: "Bank Commonwealth",
  },
  {
    merchantIds: [51],
    codeId: "244987",
    codeText: "ATMB Plus",
  },

  {
    merchantIds: [67],
    codeId: "IDRBANK001",
    codeText: "MANDIRI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK002",
    codeText: "BANK BRI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK003",
    codeText: "BANK BNI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK004",
    codeText: "BANK BCA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK005",
    codeText: "BANK UOB INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK006",
    codeText: "BANK BRI SYARIAH",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK007",
    codeText: "BANK DANAMON",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK008",
    codeText: "BANK SYARIAH MANDIRI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK009",
    codeText: "PERMATA BANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK010",
    codeText: "BANK MAYBANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK011",
    codeText: "BANK PANIN",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK012",
    codeText: "BANK CIMB NIAGA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK013",
    codeText: "BANK ARTA NIAGA KENCANA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK014",
    codeText: "BANK BUANA IND",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK015",
    codeText: "BANK LIPPO",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK016",
    codeText: "BANK OCBC NISP",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK017",
    codeText: "CITIBANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK018",
    codeText: "JP. MORGAN CHASE BANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK019",
    codeText: "BANK OF AMERICA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK020",
    codeText: "ING INDONESIA BANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK021",
    codeText: "BANK MULTICOR TBK.",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK022",
    codeText: "BANK ARTHA GRAHA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK023",
    codeText: "BANK CREDIT AGRICOLE INDOSUEZ",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK024",
    codeText: "THE BANGKOK BANK COMP. LTD",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK025",
    codeText: "THE BANK OF TOKYO MITSUBISHI UFJ LTD",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK026",
    codeText: "BANK SUMITOMO MITSUI INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK027",
    codeText: "BANK DBS INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK028",
    codeText: "BANK RESONA PERDANIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK029",
    codeText: "BANK MIZUHO INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK030",
    codeText: "STANDARD CHARTERED BANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK031",
    codeText: "BANK ABN AMRO",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK032",
    codeText: "BANK KEPPEL TATLEE BUANA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK033",
    codeText: "BANK CAPITAL INDONESIA, TBK.",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK034",
    codeText: "BANK BNP PARIBAS INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK035",
    codeText: "KOREA EXCHANGE BANK DANAMON",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK036",
    codeText: "RABOBANK INTERNASIONAL INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK037",
    codeText: "ANZ PANIN BANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK038",
    codeText: "DEUTSCHE BANK AG.",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK039",
    codeText: "BANK WOORI INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK040",
    codeText: "BANK OF CHINA LIMITED",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK041",
    codeText: "BANK BUMI ARTA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK042",
    codeText: "BANK EKONOMI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK043",
    codeText: "BANK ANTARDAERAH",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK044",
    codeText: "BANK HAGA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK045",
    codeText: "BANK IFI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK046",
    codeText: "BANK MAYAPADA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK047",
    codeText: "BANK DKI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK048",
    codeText: "BPD DIY",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK049",
    codeText: "BANK JATENG",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK050",
    codeText: "BANK JATIM",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK051",
    codeText: "BPD JAMBI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK052",
    codeText: "BPD ACEH",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK053",
    codeText: "BANK SUMUT",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK054",
    codeText: "BANK NAGARI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK055",
    codeText: "BANK RIAU",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK056",
    codeText: "BANK SUMSEL",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK057",
    codeText: "BANK LAMPUNG",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK058",
    codeText: "BPD KALSEL",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK059",
    codeText: "BPD KALIMANTAN BARAT",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK060",
    codeText: "BPD KALTIM",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK061",
    codeText: "BPD KALTENG",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK062",
    codeText: "BPD SULSEL",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK063",
    codeText: "BANK SULUT",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK064",
    codeText: "BPD NTB",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK065",
    codeText: "BPD BALI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK066",
    codeText: "BANK NTT",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK067",
    codeText: "BANK MALUKU",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK068",
    codeText: "BPD PAPUA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK069",
    codeText: "BANK BENGKULU",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK070",
    codeText: "BPD SULAWESI TENGAH",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK071",
    codeText: "BANK SULTRA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK072",
    codeText: "BANK NUSANTARA PARAHYANGAN",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK073",
    codeText: "BANK SWADESI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK074",
    codeText: "BANK MUAMALAT",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK075",
    codeText: "BANK MESTIKA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK076",
    codeText: "BANK METRO EXPRESS",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK077",
    codeText: "BANK MASPION",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK078",
    codeText: "BANK HAGAKITA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK079",
    codeText: "BANK GANESHA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK080",
    codeText: "BANK WINDU KENTJANA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK081",
    codeText: "BANK HARMONI INTERNATIONAL",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK082",
    codeText: "BANK KESAWAN",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK083",
    codeText: "BANK TABUNGAN NEGARA (PERSERO)",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK084",
    codeText: "BANK HIMPUNAN SAUDARA 1906, TBK.",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK085",
    codeText: "BANK TABUNGAN PENSIUNAN NASIONAL",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK086",
    codeText: "BANK SWAGUNA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK087",
    codeText: "BANK MEGA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK088",
    codeText: "BANK BUKOPIN",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK089",
    codeText: "BANK BISNIS INTERNASIONAL",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK090",
    codeText: "BANK JASA JAKARTA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK091",
    codeText: "BANK BUMIPUTERA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK092",
    codeText: "BANK YUDHA BHAKTI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK093",
    codeText: "BANK MITRANIAGA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK094",
    codeText: "BANK AGRO NIAGA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK095",
    codeText: "BANK INDOMONEX",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK096",
    codeText: "BANK ROYAL INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK097",
    codeText: "BANK SYARIAH MEGA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK098",
    codeText: "BANK INA PERDANA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK099",
    codeText: "PRIMA MASTER BANK",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK100",
    codeText: "BANK PERSYARIKATAN INDONESIA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK101",
    codeText: "BANK AKITA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK102",
    codeText: "BANK DIPO INTERNATIONAL",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK103",
    codeText: "BANK NOBU",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK104",
    codeText: "BANK KESEJAHTERAAN EKONOMI",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK105",
    codeText: "BANK ARTOS INDONESIA (JAGO)",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK106",
    codeText: "BANK PURBA DANARTA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK107",
    codeText: "BANK MULTI ARTA SENTOSA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK108",
    codeText: "BANK MAYORA",
  },
  {
    merchantIds: [67],
    codeId: "IDRBANK109",
    codeText: "BANK INDEX SELINDO",
  },
];

const getCodesByMerchantId = (merchantId) => {
  const normalizedMerchantId = Number(merchantId);
  const merchantCodes = codes.filter(
    (code) => code.merchantIds && code.merchantIds.indexOf(normalizedMerchantId) !== -1
  );
  if (merchantCodes.length > 0) {
    return merchantCodes;
  }
  return codes.filter((code) => !code.merchantIds || code.merchantIds.length === 0);
};

export default {
  payments: payments.filter((payment) => payment.enable),
  withdraw_type: "UPI", // BANKCARD, MOBILE_MONEY
  codes,
  getCodesByMerchantId,
  names,
  purses,
};
